import {
  DONE_STATUSES,
  EXTRA_FIELDS,
  PLANNED_STATUSES,
  STATUS_OPTIONS,
} from "./constants";

export function isDone(entry) {
  return DONE_STATUSES.includes(entry.status);
}

export function isPlanned(entry) {
  return PLANNED_STATUSES.includes(entry.status);
}

export function isInProgress(entry) {
  return !isDone(entry) && !isPlanned(entry);
}

// Single source of truth for the summary figures shown on Tracker, Stats and
// Profile. Always computed from the group's full entry list, never a filtered one.
export function summarize(entries = []) {
  const completed = entries.filter(isDone).length;
  const planned = entries.filter(isPlanned).length;

  return {
    total: entries.length,
    completed,
    planned,
    inProgress: entries.length - completed - planned,
  };
}

// Ratings are stored 1–5. The design speaks in /10, so this scales for display
// only — the stored value is never altered. Returns null when nothing is rated.
export function averageRatingOutOfTen(entries = []) {
  const rated = entries.filter((entry) => Number(entry.rating) > 0);

  if (rated.length === 0) return null;

  const sum = rated.reduce((total, entry) => total + Number(entry.rating), 0);

  return (sum / rated.length) * 2;
}

export function getStatusStyle(entry, statusOptions = STATUS_OPTIONS) {
  return statusOptions[entry.type]?.find(
    (status) => status.label === entry.status,
  );
}

export function getAddedByLabel(entry, currentUserId) {
  if (!entry.addedBy) return "Unknown";
  if (entry.addedBy.uid === currentUserId) return "You";

  return entry.addedBy.email || "Partner";
}

export function getExtraText(entry, extraFields = EXTRA_FIELDS) {
  return (extraFields[entry.type] || [])
    .map((field) => entry[field.name])
    .filter(Boolean)
    .join(" · ");
}

// Avatar colours are assigned deterministically from the member uid, so a given
// member always keeps the same colour. No member list is ever hard-coded.
const AVATAR_COLORS = ["#0077FF", "#9B59B6", "#059669", "#D97706", "#DB2777"];

export function avatarColor(key = "") {
  let hash = 0;

  for (let index = 0; index < key.length; index++) {
    hash = (hash * 31 + key.charCodeAt(index)) % 997;
  }

  return AVATAR_COLORS[hash % AVATAR_COLORS.length];
}

export function formatEntryDate(createdAt) {
  if (!createdAt?.seconds) return "";

  return new Date(createdAt.seconds * 1000).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
  });
}
